import { getConfigWithMetadata, hasAuthorization } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { deleteAllSearchAlerts as generatedDeleteAllSearchAlerts } from '@generated/search-bff/controllers/search-alert/search-alert';

/**
 * Delete all search alerts of an Account using the `/api/v4/searchalert/alert/account/{accountId}` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/searchAlerts/deleteAllSearchAlert Search API Documentation}
 */
export async function deleteAllSearchAlerts(apiConfig: ApiConfig): Promise<ApiResult<void>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'deleteAllSearchAlerts');

    if (!hasAuthorization(_apiConfig)) {
      console.warn(
        'JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`',
      );
    }

    await generatedDeleteAllSearchAlerts(_apiConfig);
    return { status: 'success', data: undefined };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
